import { render } from "./georgiaMap.vue?vue&type=template&id=16860e4d"
const script = {}

import "./georgiaMap.vue?vue&type=style&index=0&id=16860e4d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__